import { LOG_GROUP as EXTERNAL_LOG_GROUP } from '@sleepstation/logger'

// -----------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------

const LOG_GROUP = Object.freeze({
  ...EXTERNAL_LOG_GROUP,
  ROUTER: `Router`,
})

export default LOG_GROUP
